import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

function PeruBosquesProduccionLayer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="0"
      styles=""
      format="image/png"
      version="1.1.1"
      transparent
      url="https://geo.serfor.gob.pe/geoservicios/services/Servicios_OGC/Ordenamiento_Forestal/MapServer/WmsServer"
      opacity={opacity}
    />
  )
}

export default PeruBosquesProduccionLayer
